import { render, staticRenderFns } from "./PrivacyinfoDetail_20181123.vue?vue&type=template&id=63dbdf9c&scoped=true&"
import script from "./PrivacyinfoDetail_20181123.vue?vue&type=script&lang=js&"
export * from "./PrivacyinfoDetail_20181123.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyinfoDetail_20181123.vue?vue&type=style&index=0&id=63dbdf9c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dbdf9c",
  null
  
)

export default component.exports